import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

/*Component*/
import { Error404Component } from './404.component';
import { ErrorNetworkComponent } from './network.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: '404', component: Error404Component},
      {path: 'network', component: ErrorNetworkComponent},
    ])
	],
  declarations: [Error404Component, ErrorNetworkComponent]
})
export class ErrorModule {}
